/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class BloggerOutput extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    {...this.props}
                    error={this.props.error}
                    headerCopy="Select a Blog"/>
                <ChooserMain
                    {...this.props}
                    allConnectedMessage={"You've already connected all your blogs to dlvr.it"}
                    unavailableMessage={"Blogs you've already connected"}
                    typeLabel="blog"/>
            </div>
        );
    }
}

BloggerOutput.displayName = "BloggerOutput";

export default BloggerOutput;
